















import Vue from 'vue'
import { AddOnStatusElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'AddOnStatusEl',

  props: {
    templateItemData: {
      type: Object as () => AddOnStatusElInterface,
      required: true
    }
  }
})
